import React from 'react';
import './Footer.css';
import { 
    FaGithub, 
    FaLinkedin, 
    FaFileAlt, 
    FaNpm
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { personalInfo } from '../data/personalInfo';
import BrandLogo from './BrandLogo';

const platforms = [
    { label: 'GitHub', handle: personalInfo.socialLinks.github.handle, icon: FaGithub, url: personalInfo.socialLinks.github.url, cls: 'gh' },
    { label: 'LinkedIn', handle: personalInfo.socialLinks.linkedin.handle, icon: FaLinkedin, url: personalInfo.socialLinks.linkedin.url, cls: 'in' },
    { label: 'NPM Registry', handle: personalInfo.socialLinks.npm.handle, icon: FaNpm, url: personalInfo.socialLinks.npm.url, cls: 'npm' },
    { label: 'X (Twitter)', handle: personalInfo.socialLinks.twitter.handle, icon: FaXTwitter, url: personalInfo.socialLinks.twitter.url, cls: 'tw' }
];

const Footer = ({ onOpenResume }) => {
    return (
        <footer className="footer">
            <div className="cyber-grid" />
            <div className="footer-inner">
                {/* Executive Primary Row */}
                <div className="footer-content">
                    {/* Brand Signature */}
                    <div className="footer-brand-wrap">
                        <div className="footer-brand">
                            <BrandLogo size={24} className="footer-brand-logo" />
                            <span className="footer-brand-name">AMIT <span className="footer-brand-surname">KUMAR</span></span>
                            <span className="footer-brand-tag">SYSTEMS</span>
                        </div>
                        <p className="footer-tagline">
                            Senior Backend Systems Architect &amp; Full-Stack Engineer
                        </p>
                    </div>

                    {/* Controls: CV Button & Verified Developer Hub */}
                    <div className="footer-actions-wrap">
                        {onOpenResume && (
                            <button
                                type="button"
                                className="footer-cv-btn"
                                onClick={onOpenResume}
                                aria-label="Open executive resume modal"
                            >
                                <FaFileAlt className="footer-cv-icon" />
                                <span>Executive CV / Specs</span>
                            </button>
                        )}

                        <div className="footer-social-dock">
                            {platforms.map(({ label, handle, icon: Icon, url, cls }) => (
                                <a
                                    key={label}
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`footer-social-link ${cls}`}
                                    aria-label={`${label} profile (@${handle})`}
                                    title={`${label} (@${handle})`}
                                >
                                    <Icon />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Minimalist Professional Bottom Bar */}
                <div className="footer-bottom-bar">
                    <p className="footer-copyright">
                        &copy; {new Date().getFullYear()} Amit Kumar. All rights reserved.
                    </p>
                    <span className="footer-subtext">
                        Architected for Scale &amp; Performance
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;